<template>
  <div data-view="listCharacters">
    <section class="block">
      <div v-for="character in characters" :key="character.id" class="block">
        <CharacterListItem :character="character">
          <CardFooterItem :to="{ name: 'playCharacter', params: { id: character.id } }">Play</CardFooterItem>
          <CardFooterItem @click="deleteCharacter(character)">Delete</CardFooterItem>
        </CharacterListItem>
      </div>
    </section>
  </div>

  <Teleport to="#navbarEnd">
    <div class="buttons">
      <RouterLink :to="{ name: 'createCharacter' }" class="button is-primary">Create New</RouterLink>
    </div>
  </Teleport>
</template>

<script>
import { defineComponent, watch } from 'vue'
import { useRouter } from 'vue-router'

import CharacterListItem from '@/components/CharacterListItem'
import CardFooterItem from '@/components/CardFooterItem'

import useCharacters from '@/hooks/useCharacters'

export default defineComponent({
  components: {
    CharacterListItem,
    CardFooterItem
  },

  setup () {
    const router = useRouter()
    const { characters, removeCharacterById } = useCharacters()

    const deleteCharacter = (character) => {
      if (window.confirm(`Are you sure you want to delete ${character.name}?`)) {
        removeCharacterById(character.id)
      }
    }

    watch(characters, (newCharacters) => {
      if (!newCharacters.length) router.replace({ name: 'home' })
    })

    return {
      characters,
      deleteCharacter
    }
  }
})
</script>

<style lang="sass" scoped>
.listCharactersTitle
  font-family: 'Playfair Display', sans-serif
</style>
